import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import { motion } from 'motion/react';
import { Database, Search, Users, Route, Zap, CheckCircle2, Calendar, ShieldCheck, TrendingUp, ArrowRight } from 'lucide-react';
import dataCloudAssessment from '../assets/images/Marketing/Data-Cloud.png';

const DataCloudMaturityAssessment = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
        .assessment-page { font-family: 'Outfit', sans-serif; background-color: #fff; color: #0f172a; overflow-x: hidden; }
        .assessment-page * { font-family: 'Outfit', sans-serif; }

        /* Hero Section */
        .hero-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
          position: relative;
          overflow: hidden;
        }

        .hero-image-wrapper {
          position: relative;
          display: inline-block;
          z-index: 1;
        }

        .hero-shape {
          position: absolute;
          z-index: -1;
          opacity: 0.1;
          animation: float 6s ease-in-out infinite;
        }

        .hero-shape-square {
          width: 120px;
          height: 120px;
          background: #ee0000;
          top: -15px;
          right: -15px;
          border-radius: 20px;
          transform: rotate(15deg);
        }

        .hero-shape-square-2 {
          width: 100px;
          height: 100px;
          background: #067bb1;
          bottom: -20px;
          left: -20px;
          border-radius: 16px;
          transform: rotate(-15deg);
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) rotate(15deg); }
          50% { transform: translate(10px, -20px) rotate(20deg); }
        }

        @keyframes float-tri {
          0%, 100% { transform: translate(0, 0) rotate(-15deg); }
          50% { transform: translate(-15px, 15px) rotate(-10deg); }
        }
        
        .hero-tag { 
          display:inline-flex; 
          align-items:center; 
          gap:8px; 
          padding:6px 16px; 
          border-radius:999px; 
          background:#ffefef; 
          color:#ee0000; 
          border:1px solid #ffd4d4; 
          font-weight:700; 
          font-size:12px; 
          margin-bottom: 16px;
        }

        .hero-title {
          font-size: 42px;
          font-weight: 800;
          color: #000;
          margin-bottom: 12px;
          line-height: 1.1;
          letter-spacing: -0.02rem;
        }
        
        .highlight-red { color:#ee0000; }

        .hero-description {
         font-size: 20px;
  color: #2c354c;
  font-weight: 400;
  margin-bottom: 24px;
  letter-spacing: -0.01rem;
  max-width: 100%;
        }

        .btn-red { 
          text-decoration:none;
          background:#ee0000; 
          color:#fff; 
          border:none; 
          border-radius:12px; 
          padding:12px 24px; 
          font-weight:700; 
          font-size: 18px;
          box-shadow:0 12px 24px rgba(238,0,0,0.18); 
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .btn-red:hover {
          background: #cc0000;
          transform: translateY(-2px);
          color: #fff;
          box-shadow:0 15px 30px rgba(238,0,0,0.25);
        }

        /* Problem Section */
        .problem-section {
          padding: 80px 0;
          background: rgb(226, 241, 254);
          position: relative;
        }
        
        .section-pill {
         display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 999px;
  background: #ffefef;
  color: #ee0000;
  border: 1px solid #ffd4d4;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
        
        .section-title {
          font-size: 42px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 15px;
          letter-spacing: -0.02em;
        }

        .problem-card {
          background: #fff;
          border-radius: 24px;
          padding: 40px 32px;
          border: 1px solid #e2e8f0;
          height: 100%;
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
          z-index: 1;
        }
        .problem-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
          border-color: #fee2e2;
        }
        
        .icon-box-red {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          background: #ee0000;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 32px;
          box-shadow: 0 12px 24px rgba(238, 0, 0, 0.25);
          position: relative;
          z-index: 2;
          transition: all 0.3s ease;
        }
        .problem-card:hover .icon-box-red {
          transform: scale(1.05) translateY(-2px);
          box-shadow: 0 15px 30px rgba(238, 0, 0, 0.3);
        }

        .problem-card-title {
          font-size: 18px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0;
          line-height: 1.3;
          position: relative;
          z-index: 2;
          padding-bottom: 0px;
        }

        .shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }

        /* What You Gain Section */
        .gain-section {
          padding: 80px 0;
          background: #fff;
        }

        .gain-card {
          background: #fff;
          border: 2px solid #e5e7eb;
          border-radius: 24px;
          padding: 32px;
          position: relative;
          overflow: hidden;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          height: 100%;
          display: flex;
          align-items: center;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .gain-card:hover {
          border-color: rgba(238, 0, 0, 0.3);
          transform: translateY(-5px);
          box-shadow: 0 20px 40px -12px rgba(238, 0, 0, 0.15);
        }

        .gain-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          background: #ee0000;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 24px;
          color: #fff;
          flex-shrink: 0;
          box-shadow: 0 8px 20px rgba(238, 0, 0, 0.2);
          transition: all 0.3s ease;
        }
        .gain-card:hover .gain-icon-box {
          transform: scale(1.1) rotate(-5deg);
        }

        .gain-card-title {
          font-size: 20px;
          font-weight: 800;
          color: #111827;
          margin-bottom: 4px;
          line-height: 1.4;
        }

        .gain-card-text {
          font-size: 14px;
          color: #64748b;
          line-height: 1.5;
          margin-bottom: 0;
        }

        /* Framework Section */
        .framework-section {
          padding: 80px 0;
          background: linear-gradient(180deg, #effdff 0%, #effdff 100%);
          color: #fff;
        }

        .framework-card {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.1);
          background: linear-gradient(135deg, #067bb1 0%, #04467a 100%);
  border: 1px solid #067bb1;
          border-radius: 24px;
          padding: 40px;
          height: 100%;
          transition: all 0.3s ease;
        box-shadow: 0 0 0 1px rgba(24, 170, 227, 0.2), 0 20px 50px -12px rgba(24, 132, 227, 0.25);
          }
     

        .week-pill {
          display: inline-block;
          padding: 4px 12px;
          background: #ee0000;
          color: #fff;
          border-radius: 6px;
          font-weight: 700;
          font-size: 12px;
          margin-bottom: 20px;
          text-transform: uppercase;
        }

        .framework-title {
          font-size: 24px;
          font-weight: 800;
          margin-bottom: 20px;
          color: #fff;
        }

        .framework-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .framework-list li {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 12px;
          color: #cbd5e1;
          font-size: 16px;
        }
        .framework-list li svg {
          flex-shrink: 0;
          margin-top: 4px;
          color: #fff;
        }

        /* Impact Section */
        .impact-section {
          padding: 80px 0;
          background: #fff;
        }

        .impact-item {
          display: flex;
          align-items: center;
          padding: 32px 24px;
          background: #fff;
          border-radius: 24px;
          border: 1px solid #e2e8f0;
          height: 100%;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          z-index: 1;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .impact-item:hover {
          transform: translateY(-8px);
          border-color: rgba(238, 0, 0, 0.3);
          box-shadow: 0 20px 40px -12px rgba(238, 0, 0, 0.15);
        }

        .impact-icon-box {
          width: 56px;
          height: 56px;
          border-radius: 12px;
          background: #ffefef;
          color: #ee0000;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          flex-shrink: 0;
          transition: all 0.4s ease;
          position: relative;
          z-index: 2;
        }
        .impact-item:hover .impact-icon-box {
          background: #ee0000;
          color: #fff;
          transform: scale(1.1) rotate(-10deg);
        }

        .impact-text {
          font-size: 16px;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 0;
          line-height: 1.4;
          position: relative;
          z-index: 2;
        }

        /* CTA Section */
        .cta-section {
          padding: 80px 0;
          background: #effdff;
          text-align: center;
        }

        .cta-title {
        font-size: 42px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 15px;
        }

        .cta-text {
          font-size: 20px;
          margin-bottom: 40px;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          opacity: 0.9;
        }

        .btn-white {
          background: #fff;
          color: #ee0000;
          padding: 16px 40px;
          border-radius: 12px;
          font-weight: 800;
          font-size: 18px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          transition: all 0.3s ease;
        }
        .btn-white:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.2);
          color: #ee0000;
        }

        /* Decorative shapes */
        .shape-diamond { 
          position: absolute; 
          top: 20px; 
          right: 20px; 
          width: 12px; 
          height: 12px; 
          background: #fee2e2; 
          transform: rotate(45deg); 
          opacity: 0; 
          transition: all 0.4s ease; 
        }
        .problem-card:hover .shape-diamond, 
        .gain-card:hover .shape-diamond { 
          opacity: 1; 
          transform: rotate(45deg) translate(10px, -10px); 
        }
  .col-5-custom {
          flex: 0 0 auto;
          width: 20%;
        }
        @media (max-width: 1200px) {
          .col-5-custom { width: 33.333%; }
        }
        @media (max-width: 992px) {
          .col-5-custom { width: 50%; }
        }
        @media (max-width: 576px) {
          .col-5-custom { width: 100%; }
        }
      `}</style>

      <div className="assessment-page">
        {/* Hero Section */}
        <section className="hero-section">
          <Container>
            <Row className="align-items-center">
              <Col lg={7}>
                <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                  <h1 className="hero-title">
                    Data Cloud Maturity Assessment
                  </h1>
                  <p className="hero-description">
                    Gain a clear roadmap by evaluating your existing data ecosystem and transforming fragmented customer signals into real-time intelligence.
                  </p>
                  <a href="/contact" className="btn-red">
                    Schedule Your Assessment <ArrowRight size={20} />
                  </a>
                </motion.div>
              </Col>
              <Col lg={5} className="d-none d-lg-block text-center">
                <div className="hero-image-wrapper">
                  <div className="hero-shape hero-shape-square"></div>
                  <div className="hero-shape hero-shape-square-2" style={{ animationName: 'float-tri' }}></div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                  >
                    <Image src={dataCloudAssessment} alt="Data Cloud Assessment" className="img-fluid" />
                  </motion.div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Problem Section */}
        <section className="problem-section">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="section-pill">The Challenge</div> */}
              <h2 className="section-title">Why Organizations Need a Data Cloud Assessment</h2>
              <p className="text-muted fs-5 mx-auto" style={{ maxWidth: '800px' }}>
                Many enterprises struggle with complex data landscapes that hinder their ability to deliver personalized customer experiences.
              </p>
            </div>
            <Row className="g-4 justify-content-center">
              {[
                { icon: <Database />, title: "Fragmented customer data across multiple platforms" },
                { icon: <Users />, title: "Lack of a unified customer profile" },
                { icon: <Route />, title: "Limited visibility into cross-channel customer journeys" },
                { icon: <Zap />, title: "Inability to activate data for personalization and AI" },
                { icon: <TrendingUp />, title: "Low ROI from Martech and data investments" }
              ].map((item, idx) => (
                <Col key={idx} className="col-5-custom">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="problem-card"
                  >
                    <div className="shape-tr-circle"></div>
                    <div className="shape-tr-inner"></div>
                    <div className="shape-diamond"></div>
                    <div className="icon-box-red">{item.icon}</div>
                    <h4 className="problem-card-title">{item.title}</h4>
                  </motion.div>
                </Col>
              ))}
            </Row>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mt-5"
            >
              <p className="fs-4 mb-0 mx-auto text-dark" style={{ maxWidth: '900px', color: ' #4b5563' }}>
                A Data Cloud maturity assessment helps organizations identify these gaps and develop a strategy to transform fragmented data into real-time customer intelligence.
              </p>
            </motion.div>
          </Container>
        </section>

        {/* What You Gain Section */}
        <section className="gain-section">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="section-pill">Value Proposition</div> */}
              <h2 className="section-title">Key Benefits of a Data Cloud Assessment</h2>
            </div>
            <Row className="g-4">
              {[
                {
                  icon: <Search />,
                  title: "Comprehensive Audit",
                  desc: "Evaluate your current Martech stack, data architecture, and integration landscape to identify gaps and inefficiencies."
                },
                {
                  icon: <Route />,
                  title: "Journey Mapping",
                  desc: "Discover high-impact personalization and activation opportunities across marketing, sales, and service."
                },
                {
                  icon: <Database />,
                  title: "Architecture Blueprint",
                  desc: "Receive schema design recommendations and a framework for building a unified customer data layer."
                },
                {
                  icon: <Zap />,
                  title: "Actionable Roadmap",
                  desc: "Clear next steps to accelerate deployment of a scalable Customer Data Platform (CDP) or Data Cloud architecture."
                }
              ].map((item, idx) => (
                <Col key={idx} md={6}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="gain-card"
                  >
                    <div className="shape-tr-circle"></div>
                    <div className="shape-tr-inner"></div>
                    <div className="shape-diamond"></div>
                    <div className="gain-icon-box">{item.icon}</div>
                    <div>
                      <h3 className="gain-card-title">{item.title}</h3>
                      <p className="gain-card-text">{item.desc}</p>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Framework Section */}
        <section className="framework-section">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="section-pill" style={{ background: 'rgba(238,0,0,0.1)', color: '#ff4d4d' }}>The Methodology</div> */}
              <h2 className="section-title">Our 3-Week Assessment Framework</h2>
            </div>
            <Row className="g-4">
              {[
                {
                  week: "Week 1",
                  title: "Discovery and Ecosystem Analysis",
                  items: ["Martech stack audit", "Stakeholder interviews", "Data ecosystem mapping"]
                },
                {
                  week: "Week 2",
                  title: "Data and Customer Journey Analysis",
                  items: ["Customer journey mapping", "Use case prioritization", "Identity strategy"]
                },
                {
                  week: "Week 3",
                  title: "Strategy and Roadmap Development",
                  items: ["Implementation blueprint", "Governance framework", "Strategic recommendations"]
                }
              ].map((item, idx) => (
                <Col key={idx} lg={4}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="framework-card"
                  >
                    <div className="week-pill">{item.week}</div>
                    <h3 className="framework-title">{item.title}</h3>
                    <ul className="framework-list">
                      {item.items.map((li, i) => (
                        <li key={i}><CheckCircle2 size={18} /> {li}</li>
                      ))}
                    </ul>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Impact Section */}
        <section className="impact-section">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="section-pill">Results</div> */}
              <h2 className="section-title">Business Impact</h2>
              <p className="text-muted fs-5">Organizations completing this assessment achieve measurable improvements in data strategy and execution.</p>
            </div>
            <Row className="g-4 justify-content-center">
              {[
                { icon: <Zap />, text: "Real-time customer insights and activation" },
                { icon: <CheckCircle2 />, text: "Faster Salesforce Data Cloud implementation readiness" },
                { icon: <TrendingUp />, text: "Clear prioritization of high-ROI use cases" },
                { icon: <Users />, text: "Improved customer data visibility across channels" },
                { icon: <ShieldCheck />, text: "Reduced data silos and improved governance" }
              ].map((item, idx) => (
                <Col key={idx} lg={4} md={6}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="impact-item"
                  >
                    <div className="shape-tr-circle"></div>
                    <div className="shape-tr-inner"></div>
                    <div className="shape-diamond"></div>
                    <div className="impact-icon-box">{item.icon}</div>
                    <p className="impact-text">{item.text}</p>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <Container>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="cta-title">Start Your Data Cloud Transformation NOW!</h2>
              <p className="cta-text">
                Benchmark your current data maturity and build a roadmap to unlock the full value of your customer data.
              </p>
              <a href="/contact" className="btn-red">
                Schedule Your Data Cloud Assessment <Calendar size={20} />
              </a>
            </motion.div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default DataCloudMaturityAssessment;
